// extracted by mini-css-extract-plugin
module.exports = {"quote":"blockquote_quote__sHD5W"};